// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-header {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px 16px;
}
.page-header-back {
  background: var(--etaeta-color-accent);
  border: none;
  color: var(--eta-color-theme);
  flex: 0 0 auto;
}
.page-header-back:hover {
  background: var(--etaeta-color-accent-hover) !important;
  color: var(--eta-color-theme) !important;
}
.page-header-reload {
  background: var(--etaeta-color-accent);
  border: none;
  color: var(--eta-color-theme);
  flex: 0 0 auto;
  margin-left: auto;
}
.page-header-reload:hover {
  background: var(--etaeta-color-accent-hover) !important;
  color: var(--eta-color-theme) !important;
}
.page-header-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 600;
  color: var(--eta-color-theme);
}
.page-header-icon {
  display: inline-flex;
  align-items: center;
}
.page-header-icon svg {
  height: 18px;
  width: 18px;
}
/*# sourceMappingURL=PageHeader.css.map */`, "",{"version":3,"sources":["webpack://./PageHeader.less","webpack://./src/components/PageHeader/PageHeader.less"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,sBAAA;ACCJ;ADCI;EACI,sCAAA;EACA,YAAA;EACA,6BAAA;EACA,cAAA;ACCR;ADCQ;EACI,uDAAA;EACA,wCAAA;ACCZ;ADGI;EACI,sCAAA;EACA,YAAA;EACA,6BAAA;EACA,cAAA;EACA,iBAAA;ACDR;ADGQ;EACI,uDAAA;EACA,wCAAA;ACDZ;ADKI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;ACHR;ADMI;EACI,oBAAA;EACA,mBAAA;ACJR;ADEI;EAKQ,YAAA;EACA,WAAA;ACJZ;AACA,yCAAyC","sourcesContent":[".page-header {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 8px 12px 16px;\n\n    &-back {\n        background: var(--etaeta-color-accent);\n        border: none;\n        color: var(--eta-color-theme);\n        flex: 0 0 auto;\n\n        &:hover {\n            background: var(--etaeta-color-accent-hover) !important;\n            color: var(--eta-color-theme) !important;\n        }\n    }\n\n    &-reload {\n        background: var(--etaeta-color-accent);\n        border: none;\n        color: var(--eta-color-theme);\n        flex: 0 0 auto;\n        margin-left: auto;\n\n        &:hover {\n            background: var(--etaeta-color-accent-hover) !important;\n            color: var(--eta-color-theme) !important;\n        }\n    }\n\n    &-title {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        font-size: 18px;\n        font-weight: 600;\n        color: var(--eta-color-theme);\n    }\n\n    &-icon {\n        display: inline-flex;\n        align-items: center;\n\n        svg {\n            height: 18px;\n            width: 18px;\n        }\n    }\n}\n",".page-header {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 12px 16px;\n}\n.page-header-back {\n  background: var(--etaeta-color-accent);\n  border: none;\n  color: var(--eta-color-theme);\n  flex: 0 0 auto;\n}\n.page-header-back:hover {\n  background: var(--etaeta-color-accent-hover) !important;\n  color: var(--eta-color-theme) !important;\n}\n.page-header-reload {\n  background: var(--etaeta-color-accent);\n  border: none;\n  color: var(--eta-color-theme);\n  flex: 0 0 auto;\n  margin-left: auto;\n}\n.page-header-reload:hover {\n  background: var(--etaeta-color-accent-hover) !important;\n  color: var(--eta-color-theme) !important;\n}\n.page-header-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--eta-color-theme);\n}\n.page-header-icon {\n  display: inline-flex;\n  align-items: center;\n}\n.page-header-icon svg {\n  height: 18px;\n  width: 18px;\n}\n/*# sourceMappingURL=PageHeader.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
